import { PAGE_TYPE_TO_PATH_PREFIX } from '@src/constants/page-type'

const SHOP_PREFIX = `/${PAGE_TYPE_TO_PATH_PREFIX.COLLECTION}` // '/shop'

/**
 * Static fallback list of URLs to keep out of generated sitemaps.
 *
 * Source of truth at runtime is the Statsig `excluded-sitemap-urls` dynamic config; this list
 * is used only when Statsig is unavailable, returns an unrecognized config, or returns a
 * malformed value.
 */
export const EXCLUDE_URLS_FROM_SITEMAP_FALLBACK: readonly string[] = [
  '/account/my-orders-returns',
  '/account/my-profile',
  '/account/my-rewards',
  '/account/my-store-credit',
  '/log-in',
  '/sign-up',
  '/women/back-in-stock',
  '/women/new-dresses',
  '/women/new-dresses/jumpsuits',
  '/women/new-dresses/maternity',
  '/women/new-dresses/maxi-dress',
  '/women/new-dresses/midi-dresses',
  '/women/new-dresses/mini-dresses',
  '/women/new-dresses/new-arrivals-and-back-in-stock-jumpsuits',
  '/women/new-dresses/skirts',
  '/men/back-in-stock',
  '/cart-old',
  '/search-old',
  '/women/the_50_cashmere/50-cashmere',
  '/men/shirts/color/pink',
  '/get-referral',
  '/home/muberry-silk-fitted-sheet',
  '/men/back-in-stock/shirts',
  '/men/the_59_cashmere/59-cashmere',
  '/unisex/cashmere',
  '/women/back-in-stock/bracelets',
  '/women/silk/silk-camisole',
  '/women/silk/silk-slip-dress',
  '/women/tops',
  '/cashmere-landing',
  '/do-not-delete-this-collection',
  '/test-custom-landing-page',
  '/tracking',
  '/account/returns',
  '/accounts/cancel',
  '/women/new-arrivals/all-products',
  '/women/best-sellers/all-products',
  '/men/new-arrivals/all-products',
  '/men/best-sellers/all-products',
  '/home/rugs-shop-all/all-products',
  '/home/new-arrivals/all-products',
  '/home/decorative-trays/all-products',
  '/home/best-sellers/all-products',
  '/gifts/valentines/all-products',
  '/collections/new-arrivals/all-products',
  '/baby-&-kids/new-arrivals/all-products',
  '/home_page1',
  '/home_page2',
  '/home_page3',
  '/home-new',
]

/**
 * Returns each URL plus its `/shop`-prefixed twin (deduped). UK CLPs are served natively under
 * `/shop/*`; the BFF sitemap emits those paths, so exclusion entries must match both forms.
 * Entries already under `/shop/` are left untouched.
 */
export function withShopPathVariants(urls: readonly string[]): string[] {
  const out = new Set<string>()
  for (const url of urls) {
    out.add(url)
    if (url.startsWith(`${SHOP_PREFIX}/`)) continue
    // Guarantee a separator: a no-leading-slash entry (e.g. a live Statsig 'home/x') must yield
    // '/shop/home/x', not the malformed '/shophome/x'.
    out.add(url.startsWith('/') ? `${SHOP_PREFIX}${url}` : `${SHOP_PREFIX}/${url}`)
  }
  return [...out]
}
